import React from "react";
import { FaPlug, FaEdit } from "react-icons/fa";

export default function IntegrationSection() {
  return (
    <section className="py-16 md:py-20 bg-gradient-to-b from-white via-snaptrix-blue-50 to-white" aria-labelledby="integrations-heading">
      <div className="max-w-7xl mx-auto px-6">
        <h2
          id="integrations-heading"
          className="text-3xl md:text-4xl font-bold text-center mb-12 md:mb-16 text-snaptrix-gray-700"
        >
          Powerful Integrations
        </h2>
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Play-Cricket Integration */}
          <div className="text-center md:text-left p-6 md:p-8 bg-snaptrix-gray-50 rounded-xl hover:shadow-lg transition-shadow duration-300">
            <div className="flex justify-center md:justify-start mb-6">
              <div className="p-4 bg-snaptrix-blue-100 rounded-full">
                <FaPlug
                  className="text-snaptrix-blue-600 text-5xl md:text-6xl"
                  aria-hidden="true"
                />
              </div>
            </div>
            <h3 className="text-2xl md:text-3xl font-bold mb-4 text-snaptrix-gray-700">
              Seamless Play-Cricket Integration
            </h3>
            <p className="text-lg text-snaptrix-gray-600 leading-relaxed">
              Snaptrix connects directly with Play-Cricket to automatically fetch
              match details — from player lineups to full scorecards — saving you
              time and ensuring accuracy.
            </p>
          </div>

          {/* Built-in Editor */}
          <div className="text-center md:text-left p-6 md:p-8 bg-gradient-to-br from-purple-50 to-snaptrix-blue-50 rounded-xl hover:shadow-xl transition-all duration-300 hover:scale-[1.02] border border-purple-100">
            <div className="flex justify-center md:justify-start mb-6">
              <div className="p-4 bg-gradient-to-br from-purple-100 to-snaptrix-blue-100 rounded-full shadow-md hover:shadow-lg transition-shadow duration-300">
                <FaEdit
                  className="text-snaptrix-blue-600 text-5xl md:text-6xl"
                  aria-hidden="true"
                />
              </div>
            </div>
            <h3 className="text-2xl md:text-3xl font-bold mb-4 text-snaptrix-gray-700">
              Built-in Editor
            </h3>
            <p className="text-lg text-snaptrix-gray-600 leading-relaxed">
              Fine-tune your posts before sharing. Edit player names, stats, and
              visuals with our intuitive inbuilt editor for a perfect finish every
              time.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
